import { getUrlParams, isEmptyValue } from '@/utils/common'
import { DatePicker, Form, Input, Select, Upload, UploadFile } from 'antd'
import { useAtom } from 'jotai'
import moment from 'moment'
import { useEffect, useState } from 'react'
import './RequiredFields.style.less'
import { find } from 'lodash'
import {
  currentUserAssignment,
  disableFields,
  getFieldName,
} from '../../EditOrder.helper'
import { useAuth } from '@/providers/auth.provider'
import { isFieldChangeAtom } from '@/jotai/order.jotai'

// required form contains picture, status, number, to_be_delivered_date

interface Props {
  form: any
  orderSetting?: any
  orderAssignments?: any
  orderData: any
  supplier: any
}

function RequiredFields(props: Props) {
  const [fileList, setfileList] = useState<UploadFile[]>([])
  const [disableFactory, setDisableFactory] = useState(true)
  const [factory, setFactory] = useState([])
  const [, setFieldChange] = useAtom(isFieldChangeAtom)

  const { user } = useAuth()

  const typeKey = getUrlParams('type')

  useEffect(() => {
    const selectedSupplier = find(
      props.supplier,
      (item) => item.id == props.orderData?.supplier?.id
    )
    if (!isEmptyValue(selectedSupplier)) {
      setDisableFactory(false)
      const factories = selectedSupplier?.is_factory
        ? [selectedSupplier]
        : selectedSupplier?.factories.filter((item) => item.status == 'active')
      setFactory(factories)
      props.form.setFieldsValue({
        ['factory']: validateInitialValues(
          factories,
          props.orderData?.factory?.id
        ),
      })
    }
  }, [])

  const normFile = (e: any) => {
    setfileList(e.fileList)
    if (Array.isArray(e)) {
      return e
    }
    return e?.fileList
  }

  useEffect(() => {
    if (props?.orderData?.picture) {
      setfileList([
        {
          uid: '-1',
          name: props?.orderData?.picture?.name,
          status: 'done',
          url: props?.orderData?.picture?.url_path,
        },
      ])
    }
  }, [])

  const onSupplierChange = (data) => {
    setFieldChange(true)
    props.form.setFieldsValue({
      ['factory']: null,
    })
    const selectedSupplier = find(props.supplier, (item) => item.id == data)
    setFactory(
      selectedSupplier?.is_factory
        ? [selectedSupplier]
        : selectedSupplier?.factories.filter((item) => item.status == 'active')
    )
    if (selectedSupplier?.is_factory) {
      props.form.setFieldsValue({
        ['factory']: selectedSupplier.id,
      })
    }
    setDisableFactory(false)
  }

  useEffect(() => {
    props.form.setFieldValue(
      'picture',
      !isEmptyValue(props.orderData?.picture)
        ? [props.orderData?.picture]
        : null
    )
  }, [props.orderData])

  const validateInitialValues = (data, value) => {
    if (data?.some((item) => item.id == value)) return value
    return null
  }

  return (
    <>
      <Form.Item
        name={'number'}
        labelCol={{ span: 6 }}
        labelAlign="left"
        label={
          getFieldName(props?.orderSetting?.field_names, 'number') ??
          'Order Number'
        }
        initialValue={props.orderData?.number}
        rules={[
          {
            required: true,
            message: '',
          },
        ]}
      >
        <Input
          disabled={
            typeKey !== 'clone' &&
            disableFields(
              props?.orderSetting?.internal_fields,
              'number',
              !isEmptyValue(props?.orderAssignments)
                ? currentUserAssignment(props?.orderAssignments, user)
                : {}
            )
          }
          onChange={() => setFieldChange(true)}
          placeholder="Text"
          size="large"
        />
      </Form.Item>

      <Form.Item
        name={'picture'}
        valuePropName="fileListOrder"
        label={
          getFieldName(props?.orderSetting?.field_names, 'picture') ??
          'Order Picture'
        }
        labelCol={{ span: 6 }}
        getValueFromEvent={normFile}
      >
        <Upload
          onChange={() => setFieldChange(true)}
          listType="picture-card"
          maxCount={1}
          accept="image/png, image/jpeg, image/jpg, image/bmp, image/webp"
          disabled={
            typeKey !== 'clone' &&
            disableFields(
              props?.orderSetting?.internal_fields,
              'picture',
              !isEmptyValue(props?.orderAssignments)
                ? currentUserAssignment(props?.orderAssignments, user)
                : {}
            )
          }
          fileList={fileList}
          method={'GET' as any}
          beforeUpload={() => false}
        >
          {fileList.length > 0 ? null : '  + Picture'}
        </Upload>
      </Form.Item>
      <Form.Item
        name={'to_be_delivered_date'}
        labelCol={{ span: 6 }}
        labelAlign="left"
        label={
          getFieldName(
            props?.orderSetting?.field_names,
            'to_be_delivered_date'
          ) ?? 'Delivery Date'
        }
        initialValue={moment(props.orderData?.to_be_delivered_date)}
        rules={[
          {
            required: true,
            message: '',
          },
        ]}
      >
        <DatePicker
          onChange={() => setFieldChange(true)}
          disabled={
            typeKey !== 'clone' &&
            disableFields(
              props.orderSetting?.internal_fields,
              'to_be_delivered_date',
              !isEmptyValue(props?.orderAssignments)
                ? currentUserAssignment(props?.orderAssignments, user)
                : {}
            )
          }
          placeholder="Date"
          size="large"
          format={'DD MMM YYYY'}
        />
      </Form.Item>
      <Form.Item
        name={'supplier'}
        labelCol={{ span: 6 }}
        labelAlign="left"
        label={
          getFieldName(props?.orderSetting?.field_names, 'supplier') ??
          'Supplier'
        }
        initialValue={validateInitialValues(
          props.supplier,
          props.orderData?.supplier?.id
        )}
        rules={[
          {
            required: true,
            message: '',
          },
        ]}
      >
        <Select
          onChange={onSupplierChange}
          showSearch
          allowClear
          placeholder="Select"
          size="large"
          optionFilterProp="label"
          disabled={
            typeKey !== 'clone' &&
            disableFields(
              props.orderSetting?.internal_fields,
              'supplier',
              !isEmptyValue(props?.orderAssignments)
                ? currentUserAssignment(props?.orderAssignments, user)
                : {}
            )
          }
          options={props.supplier?.map((item) => {
            return {
              label: item?.name,
              value: item.id,
            }
          })}
        />
      </Form.Item>

      <Form.Item
        name={'factory'}
        labelCol={{ span: 6 }}
        labelAlign="left"
        label={
          getFieldName(props?.orderSetting?.field_names, 'factory') ?? 'Factory'
        }
        rules={[
          {
            required: true,
            message: '',
          },
        ]}
      >
        <Select
          disabled={
            disableFactory ||
            (typeKey !== 'clone' &&
              disableFields(
                props.orderSetting?.internal_fields,
                'factory',
                !isEmptyValue(props?.orderAssignments)
                  ? currentUserAssignment(props?.orderAssignments, user)
                  : {}
              ))
          }
          onChange={() => setFieldChange(true)}
          showSearch
          placeholder="Select"
          size="large"
          optionFilterProp="label"
          allowClear
          options={factory?.map((item) => {
            return {
              label: item?.name,
              value: item.id,
            }
          })}
        />
      </Form.Item>
    </>
  )
}

export default RequiredFields
